var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.59,47.78l-29.53-29.53c-4.45-4.45-11.66-4.45-16.11,0l-29.53,29.53c-1.48,1.48-1.48,3.89,0,5.37,1.48,1.48,3.89,1.48,5.37,0l2.31-2.31v22.87c0,6.29,5.1,11.39,11.39,11.39h37.03c6.29,0,11.39-5.1,11.39-11.39v-22.87l2.31,2.31c1.48,1.48,3.89,1.48,5.37,0h0c1.48-1.48,1.48-3.89,0-5.37ZM72.31,73.7c0,2.1-1.7,3.8-3.8,3.8H31.48c-2.1,0-3.8-1.7-3.8-3.8v-30.46s19.63-19.63,19.63-19.63c1.48-1.48,3.89-1.48,5.37,0l19.63,19.63v30.46Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeHome);
export default __webpack_public_path__ + "static/media/acae_home.66514cd5.svg";
export { ForwardRef as ReactComponent };